import { withStyles } from '@material-ui/core/styles';
import DialogContent from '@material-ui/core/DialogContent';

export default withStyles({
  root: {
    textAlign: 'center',
  },
})(DialogContent);
